(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iprevail-vending"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('iprevail-vending')) {
  customElements.define('iprevail-vending', class extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.q = selector => this.querySelector(selector);
      this.controller = new AbortController();
      this.config = JSON.parse(this.q('[data-vm-config]').textContent);
      this.key = 'iprevail-vending-no-app-september-2026';
      this.buttons = [...this.querySelectorAll('[data-play]')];
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.config.currency});
      this.buttons.forEach(button => button.addEventListener('click',()=>this.play(),{signal:this.controller.signal}));
      this.q('[data-variant]').addEventListener('change',()=>this.selection(),{signal:this.controller.signal});
      this.q('[data-shop]').addEventListener('click',()=>this.claim(),{signal:this.controller.signal});
      window.addEventListener('storage', event => {
        if (event.key === this.key && event.newValue && !this.busy) {
          try { this.saved=this.readPick(); this.buttons.forEach(b=>{b.disabled=true;}); this.reveal(this.saved,false).catch(error=>this.error(error)); } catch(error) { this.error(error); }
        }
      }, {signal:this.controller.signal});
      if (!this.config.enabled) {this.q('[data-status]').textContent=this.config.strings.paused;return;}
      try {
        this.saved=this.readPick();
        if (this.saved) await this.reveal(this.saved,false);
        else this.buttons.forEach(b=>{b.disabled=false;});
      } catch (error) {this.error(error);}
    }
    disconnectedCallback() {this.controller?.abort();this.started=false;}
    readPick() {
      try {
        const raw=localStorage.getItem(this.key);
        if(!raw)return null;
        const pick=JSON.parse(raw);
        if(typeof pick?.handle!=='string'||!Number.isInteger(pick.slot)||pick.slot<0||pick.slot>11)throw Error();
        return pick;
      } catch {throw new Error('storage_unavailable');}
    }
    savePick(pick) {
      try {localStorage.setItem(this.key,JSON.stringify(pick));}
      catch {throw new Error('storage_unavailable');}
    }
    error(error) {
      this.q('[data-status]').textContent=error.message==='storage_unavailable'?this.config.strings.storage:error.message==='product_unavailable'?this.config.strings.empty:this.config.strings.error;
    }
    light(index){this.slots.forEach((slot,i)=>slot.classList.toggle('is-lit',i===index));}
    random(length){const values=new Uint32Array(1);crypto.getRandomValues(values);return Math.floor(values[0]/4294967296*length);}
    async liveProduct(base) {
      const endpoint=new URL(base.url,location.origin);endpoint.pathname+='.js';
      const response=await fetch(endpoint,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
      if(!response.ok)throw new Error('connection_error');
      const product=await response.json();
      const variants=(product.variants||[]).filter(v=>v.available);
      if(!product.available||product.requires_selling_plan||!variants.length)throw new Error('product_unavailable');
      return {...base,variants};
    }
    async choosePick() {
      const stored=this.readPick();if(stored)return stored;
      const bases=[...new Map(this.config.products.map(p=>[p.handle,p])).values()];
      const results=await Promise.allSettled(bases.map(p=>this.liveProduct(p)));
      const available=results.filter(r=>r.status==='fulfilled').map(r=>r.value);
      if(!available.length)throw new Error(results.some(r=>r.status==='rejected'&&r.reason.message!=='product_unavailable')?'connection_error':'product_unavailable');
      const latest=this.readPick();if(latest)return latest;
      const product=available[this.random(available.length)];
      const pick={handle:product.handle,slot:this.random(12),variantId:String(product.variants[0].id)};
      this.savePick(pick);
      return pick;
    }
    async spin(target){
      if(!matchMedia('(prefers-reduced-motion:reduce)').matches){
        for(let i=0;i<22;i++){if(!this.isConnected)return;this.light((target+i+3)%12);await new Promise(r=>setTimeout(r,65+i*5));}
      }
      this.light(target);
    }
    async play(){
      if(this.busy||this.current||!this.config.enabled)return;
      this.busy=true;this.buttons.forEach(b=>{b.disabled=true;});
      this.q('[data-status]').textContent=this.config.strings.choosing;
      try{
        this.saved=navigator.locks?await navigator.locks.request(this.key,()=>this.choosePick()):await this.choosePick();
        await this.spin(this.saved.slot);
        if(this.isConnected)await this.reveal(this.saved,true);
      }catch(error){this.error(error);}
      finally{this.busy=false;if(!this.saved&&!this.current)this.buttons.forEach(b=>{b.disabled=false;});}
    }
    async reveal(result,focus){
      if(!result)return;
      this.saved=result;this.buttons.forEach(b=>{b.disabled=true;});
      const base=this.config.products.find(p=>p.handle===result.handle);
      if(!base)throw new Error('product_unavailable');
      this.current=await this.liveProduct(base);
      this.classList.add('is-revealed');this.q('[data-start]').hidden=true;this.q('[data-result]').hidden=false;
      this.q('[data-product-title]').textContent=base.title;
      const img=this.q('[data-product-image]');if(base.image){img.src=base.image;img.alt=base.title;img.hidden=false;}
      const select=this.q('[data-variant]');
      select.replaceChildren(...this.current.variants.map(v=>{const opt=document.createElement('option');opt.value=String(v.id);opt.textContent=v.title;return opt;}));
      if(this.current.variants.some(v=>String(v.id)===String(result.variantId)))select.value=String(result.variantId);
      this.q('[data-sale-price]').textContent=this.config.strings.mystery;
      this.q('[data-led]').textContent=String(result.slot+1).padStart(2,'0');this.light(result.slot);
      this.q('[data-shop]').disabled=false;
      this.q('[data-status]').textContent='';
      this.selection();
      if(focus){this.q('[data-product-title]').focus({preventScroll:true});if(matchMedia('(max-width:899px)').matches)this.q('.vm__controls').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});}
    }
    selection(){
      const v=this.current?.variants.find(v=>String(v.id)===this.q('[data-variant]').value);
      if(v){this.q('[data-original-price]').textContent=this.money.format(v.price/100);this.saved={...this.saved,variantId:String(v.id)};try{this.savePick(this.saved);}catch(error){this.error(error);}}
    }
    async claim(){
      if(!this.config.enabled||this.busy||!this.current)return;
      this.busy=true;this.q('[data-shop]').disabled=true;this.q('[data-status]').textContent=this.config.strings.claiming;
      let cartMutationStarted=false;
      try{
        const variantId=this.q('[data-variant]').value;
        const live=await this.liveProduct(this.current);
        if(!live.variants.some(v=>String(v.id)===variantId))throw new Error('product_unavailable');
        const claimKey='vending-september-2026';
        const cartRes=await fetch(this.config.root+'cart.js',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
        if(!cartRes.ok)throw new Error('connection_error');
        const cart=await cartRes.json();
        const old=cart.items.filter(item=>item.properties?._vending_claim===claimKey);
        const exact=old.find(item=>String(item.variant_id)===variantId);
        if(old.length&&!exact){
          cartMutationStarted=true;
          const updates=Object.fromEntries(old.map(item=>[item.key,0]));
          const removed=await fetch(this.config.root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates}),signal:AbortSignal.timeout(10000)});
          if(!removed.ok)throw new Error('cart_uncertain');
        }
        if(!exact){
          cartMutationStarted=true;
          const add=await fetch(this.config.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties:{_vending_claim:claimKey}}]}),signal:AbortSignal.timeout(10000)});
          if(!add.ok)throw new Error('cart_uncertain');
        }
        const destination=new URL(this.config.cartUrl,location.origin);
        if(this.config.previewTheme)destination.searchParams.set('preview_theme_id',this.config.previewTheme);
        location.assign(this.config.root+'discount/'+encodeURIComponent(this.config.code)+'?redirect='+encodeURIComponent(destination.pathname+destination.search));
      }catch(error){
        if(cartMutationStarted){this.q('[data-status]').textContent=this.config.strings.cartRetry;this.q('[data-browse]').hidden=false;}
        else this.error(error);
        this.q('[data-shop]').disabled=false;
      }finally{this.busy=false;}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
